import React from 'react'
import { Link } from 'gatsby'
import '../Side-bar/side-bar.css'
import Menu from '../Board-Menu/menu'

const SideBar = obj => {
  return (
    <div className="sidebar-wrapper">
      <div className="community">{/*  <Menu /> */}</div>

      <ul>
        <li>
          <a href="https://www.crea.ca/housing-market-stats/canadian-housing-market-stats/quarterly-forecasts/">
            Quarterly Forecasts
          </a>
        </li>
        <li>
          <a href="https://www.crea.ca/housing-market-stats/national-price-map/">
            National Price Map
          </a>
        </li>
      </ul>
      <br />
      <div className="widgets widget_1">
        <h2>Why A Realtor<sup>®</sup>?</h2>
        <p>
          Whether you're buying or selling, a real estate transaction can be
          complicated. A REALTOR® helps by making it easy for you...
          <a href="https://www.crea.ca/buyers-or-sellers/why-a-realtor/">
            Read more ›
          </a>
        </p>
      </div>
      <div className="widgets widget_2">
        <h2>How CREA Helps</h2>
        <p>
          Whether you're buying or selling, a real estate transaction can be
          complicated. A REALTOR® helps by making it easy for you...
          <a href="https://www.crea.ca/buyers-or-sellers/crea-resources/">
            Read more ›
          </a>
        </p>
      </div>
      <div className="widgets widget_3">
        <h2>Get Info And Stats</h2>
        <p>
          Whether you're buying or selling, a real estate transaction can be
          complicated. A REALTOR® helps by making it easy for you...
          <a href="https://www.crea.ca/housing-market-stats/">Read more ›</a>
        </p>
      </div>
    </div>
  )
}

export default SideBar
